


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import copy from '@/utils/copy';


@Component({})
export default class ChartSlow extends Vue {
  @Prop() private data!: any;
  @Prop() private intervalTime!: any;
  private appChange(i: any) {
    const temp = { key: `${i.key}`, label: i.label };
  }
  get maxValue() {
    const temp: number[] = this.data.map((i: any) => i.value);
    return Math.max.apply(null, temp);
  }
  private getTraceId(i: any) {
    return i.traceIds && i.traceIds[0] ? ` - ${i.traceIds[0]}` : '';
  }
  private handleClick(i: any) {
    copy(i);
  }
}
